import axios from 'axios'

export const getPromotions = () => {
  return axios.get('/data/sadarbības_partnera_akcija').then((resp) => resp.data)
}
